import { render, staticRenderFns } from "./g-avatar.vue?vue&type=template&id=72362534"
import script from "./g-avatar.vue?vue&type=script&lang=js"
export * from "./g-avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports